import React from 'react';
import PropTypes from 'prop-types';
import { withProps } from 'recompose';
import { phonePropType } from 'config/propTypes';

import { H4, Paragraph } from 'components/core/Typography';
import { Group } from 'components/core/Page';
import { SearchBox } from 'components/search/SearchBox';
import { ClickToCall } from 'components/facility/ClickToCall';

import './NoResults.scss';

/* eslint-disable max-len */
export const errors = {
	default: 'Oh no! Something went wrong while we were searching for you! Would you like to try again?',
	'No location found': 'We were unable to parse that search location. Please check the search field below and try again.',
	'No location entered': 'There appears to be no location entered. Please enter your zip code or city.',
	'Location is outside US': 'The location you entered appears to be outside of the USA. Please check the search field below and try again.'
};
/* eslint-enable */

export const enhance = withProps(
	({ error }) => ({
		error: errors[error] || errors.default
	})
);

export function SearchError({
	error, onSearch, phone, actions
}) {
	return (
		<div className="no-results">
			<div className="content">
				<Group>
					<Paragraph size="small">
						{error}
					</Paragraph>
				</Group>
				{!!onSearch &&
					<div className="search-wrapper">
						<SearchBox onSearch={onSearch} />
					</div>
				}
			</div>
			<div className="need-help">
				<H4 size="medium">
					Need help finding the perfect storage? Give us a call!
				</H4>
				<ClickToCall
					phone={phone}
					onFetchNumber={actions.getTollfreePhoneNumber}
				/>
			</div>
		</div>
	);
}

SearchError.propTypes = {
	error: PropTypes.string,
	onSearch: PropTypes.func,
	phone: phonePropType,
	actions: PropTypes.shape({
		getTollfreePhoneNumber: PropTypes.func.isRequired
	}).isRequired
};

export default enhance(SearchError);
